import React, { Component } from "react";
import FadeIn from "react-fade-in";
import IconLigthBulb from '../images/icon/icon-light-bulb.png';

class Note extends Component {
  constructor(props) {
    super();
  }
  render() {
    let title = this.props.title;
    let content = this.props.content;
    let myContent = { __html: content }
    if (title && content) {
      return (
        <FadeIn>
          <div className="note">
            <div className="wrapper">
              <h2>
                <img src={IconLigthBulb} className="icon-light-bulb" alt="Icon Light Bulb" />
                {title}
              </h2>
              <span dangerouslySetInnerHTML={myContent}></span>
            </div>
          </div>
        </FadeIn>
      );
    } else {
      return null;
    }
  }
}

export default Note;
